import React from 'react';
import 'assets/styles/progressBar.scss';

export const ProgressBar = (props) => {
  const {
    label = '',
    percentage = 0,
    className = '',
    showPercentage = true,
    color = '#17a2b8',
    backgroundColor = '#e9ecef',
    height = '20px',
  } = props;

  const normalizedPercentage = Math.max(0, Math.min(100, percentage));

  return (
    <div className={`progress-bar-container ${className}`}>
      {(label || showPercentage) && (
        <div className="progress-bar-header">
          {label && <span className="progress-bar-label">{label}</span>}
          {showPercentage && (
            <span className="progress-bar-percentage">{normalizedPercentage}%</span>
          )}
        </div>
      )}
      <div
        className="progress-bar-track"
        style={{
          backgroundColor: backgroundColor,
          height: height,
        }}
      >
        <div
          className="progress-bar-fill"
          style={{
            width: `${normalizedPercentage}%`,
            backgroundColor: color,
            height: '100%',
          }}
        />
      </div>
    </div>
  );
};